'use strict';

exports.__esModule = true;

var _glamor = require('glamor');

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Container
// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
var container = (0, _glamor.css)({
  width: '100%',
  margin: '0px auto'
});
var containerClass = container.toString();

var defaultContainer = (0, _glamor.css)({
  maxWidth: 1280,
  '@media(min-width: 992px)': {
    maxWidth: 1280
  }
});
var defaultContainerClass = defaultContainer.toString();

var blockStyleObject = (0, _glamor.css)({
  display: 'block'
});
var blockClass = blockStyleObject.toString();

var flexStyleObject = (0, _glamor.css)({
  display: 'flex'
});
var flexClass = flexStyleObject.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Big
var bigContainer = (0, _glamor.css)({
  maxWidth: 1600,
  '@media(min-width: 992px)': {
    maxWidth: 1600
  }
});
var bigContainerClass = bigContainer.toString();

var giantContainer = (0, _glamor.css)({
  maxWidth: 2000,
  '@media(min-width: 992px)': {
    maxWidth: 2000
  }
});
var giantContainerClass = giantContainer.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Bleed
var bleedContainer = (0, _glamor.css)({
  maxWidth: '100%',
  '@media(min-width: 992px)': {
    maxWidth: '100%'
  }
});
var bleedContainerClass = bleedContainer.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ goldenMajor, goldenMinor
var goldenMajorStyleObject = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 992px)': {
    maxWidth: '62.5%'
  }
});
var goldenMajorClass = goldenMajorStyleObject.toString();

var goldenMinorStyleObject = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 992px)': {
    maxWidth: '37.5%'
  }
});
var goldenMinorClass = goldenMinorStyleObject.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ threeQuarters
var threeQuartersStyleObject = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 992px)': {
    maxWidth: '75%'
  }
});
var threeQuartersClass = threeQuartersStyleObject.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Small
var smallContainer = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 992px)': {
    maxWidth: '50%'
  }
});
var smallContainerClass = smallContainer.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Tiny
var tinyContainer = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 992px)': {
    maxWidth: '37.5%'
  }
});
var tinyContainerClass = tinyContainer.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** containerFn */
var containerFn = function containerFn() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$tiny = _ref.tiny,
      tiny = _ref$tiny === undefined ? false : _ref$tiny,
      _ref$small = _ref.small,
      small = _ref$small === undefined ? false : _ref$small,
      _ref$big = _ref.big,
      big = _ref$big === undefined ? false : _ref$big,
      _ref$giant = _ref.giant,
      giant = _ref$giant === undefined ? false : _ref$giant,
      _ref$bleed = _ref.bleed,
      bleed = _ref$bleed === undefined ? false : _ref$bleed,
      _ref$threeQuarters = _ref.threeQuarters,
      threeQuarters = _ref$threeQuarters === undefined ? false : _ref$threeQuarters,
      _ref$goldenMajor = _ref.goldenMajor,
      goldenMajor = _ref$goldenMajor === undefined ? false : _ref$goldenMajor,
      _ref$goldenMinor = _ref.goldenMinor,
      goldenMinor = _ref$goldenMinor === undefined ? false : _ref$goldenMinor,
      _ref$block = _ref.block,
      block = _ref$block === undefined ? false : _ref$block,
      _ref$flex = _ref.flex,
      flex = _ref$flex === undefined ? false : _ref$flex,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? undefined : _ref$className;

  var definedClassName = containerClass;

  // Container width
  if (tiny === true) {
    definedClassName += ' ' + tinyContainerClass;
  }
  if (small === true) {
    definedClassName += ' ' + smallContainerClass;
  }
  if (big === true) {
    definedClassName += ' ' + bigContainerClass;
  }
  if (giant === true) {
    definedClassName += ' ' + giantContainerClass;
  }
  if (bleed === true) {
    definedClassName += ' ' + bleedContainerClass;
  }
  if (threeQuarters === true) {
    definedClassName += ' ' + threeQuartersClass;
  }
  if (goldenMajor === true) {
    definedClassName += ' ' + goldenMajorClass;
  }
  if (goldenMinor === true) {
    definedClassName += ' ' + goldenMinorClass;
  }
  if (tiny === false && small === false && big === false && giant === false && bleed === false && threeQuarters === false && goldenMajor === false && goldenMinor === false) {
    definedClassName += ' ' + defaultContainerClass;
  }

  // Block or flex
  if (block === true) {
    definedClassName += ' ' + blockClass;
  }
  if (flex === true) {
    definedClassName += ' ' + flexClass;
  }
  if (block === false && flex === false) {
    definedClassName += ' ' + blockClass;
  }

  // Other classnames
  if (!(0, _isUndefined2.default)(className)) {
    definedClassName += ' ' + className;
  }

  return definedClassName;
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
exports.default = containerFn;
module.exports = exports['default'];